import './slider.css';
import AssetImg from '../lib/asset-img';
import { useState, useEffect } from 'react';
import Slick from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export function FromParameters({pageID}) {
    const [numImgs, setNumImgs] = useState(null);

    useEffect(() => {
        if (pageID !== null) {
            fetch(`/v1/api/pages/${pageID}/parameters/imgs`)
                .then(res => res.json())
                .then(data => setNumImgs(data.range))
                .catch(err => console.error('Error fetching page parameters:', err));
        }
    }, [pageID]);

    return <Slider>
        {[...Array(numImgs)].map((_, i) => <AssetImg id={i} url={`/v1/api/pages/${pageID}/parameters/imgs/${i}`} />)}
    </Slider>;
}

export default function Slider({ children }) {
    const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <div className="slider">
            <Slick {...settings}>
                {children}
            </Slick>
        </div>
    );
}
